export const FETCH_ORG_PROFILE_DATA_REQUEST = "FETCH_ORG_PROFILE_DATA_REQUEST";
export const FETCH_ORG_PROFILE_DATA_SUCCESS = "FETCH_ORG_PROFILE_DATA_SUCCESS";
export const FETCH_ORG_PROFILE_DATA_ERROR = "FETCH_ORG_PROFILE_DATA_ERROR";

export const UPDATE_ORG_PROFILE_NAME="UPDATE_ORG_PROFILE_NAME";
export const SET_UPDATING_DATA="SET_UPDATING_DATA";
export const UPDATE_ORG_PROFILE_INFO_SUCCESS="UPDATE_ORG_PROFILE_INFO_SUCCESS";

export const UPDATE_ORG_PROFILE_SUBDOMAIN="UPDATE_ORG_PROFILE_SUBDOMAIN";

export const UPDATE_ORG_PROFILE_PHONE ="UPDATE_ORG_PROFILE_PHONE";

export const UPDATE_ORG_PROFILE_FAX ="UPDATE_ORG_PROFILE_FAX";

export const UPDATE_ORG_PROFILE_TIMEZONE="UPDATE_ORG_PROFILE_TIMEZONE";

export const FETCH_ORG_PROPERTY_LOCATION="FETCH_ORG_PROPERTY_LOCATION"
export const FETCH_ORG_PROPERTY_LOCATION_SUCCESS="FETCH_ORG_PROPERTY_LOCATION_SUCCESS";
export const FETCH_ORGSKILLSETS_SUCCESS = "FETCH_ORGSKILLSETS_SUCCESS";
export const UPDATE_ORG_PROPERTY_LOCATION="UPDATE_ORG_PROPERTY_LOCATION";

export const UPDATE_ORG_IMAGE_COORDINATES="UPDATE_ORG_IMAGE_COORDINATES";

export const REMOVE_ORG_SKILLSET ="REMOVE_ORG_SKILLSET";
export const FETCH_ALL_SKILSET = "FETCH_ALL_SKILSET";

export const ADD_ORG_SKILLSET="ADD_ORG_SKILLSET";

export const FETCH_LOCATION_NAMES="FETCH_LOCATION_NAMES";
export const FETCH_ZIP_DATA ="FETCH_ZIP_DATA";

export const ADD_REMOVE_SERVICE_LOCATION_NAMES ="ADD_REMOVE_SERVICE_LOCATION_NAMES";

export const REMOVE_ORG_LOGO = "REMOVE_ORG_LOGO";
export const REMOVE_ORG_LOGO_SUCCESS="REMOVE_ORG_LOGO_SUCCESS";

export const UPDATE_ORG_LOGO="UPDATE_ORG_LOGO";

export const SET_UPDATING_ORG_DATA="SET_UPDATING_ORG_DATA";

export const UPDATE_ORG_IMAGE_URL="UPDATE_ORG_IMAGE_URL";
